import styled from 'styled-components';

import Assigned from './container';

export default styled(Assigned)`
  width: 1603px;
  margin: 0 auto;
`;
